<app-sidebar></app-sidebar>
<div class="content">
  <router-outlet></router-outlet>
</div>
